import { useState } from 'react'
import { Trans } from '@lingui/react/macro'

import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import { ModalDialog } from '@jotta/ui/ModalDialog'
import { SupportChannels } from '@jotta/ui/SupportChannels'
import SvgLogoMain from '@jotta/ui/SvgLogo_mainLight'

import { Captcha } from './Captcha'
import type { CaptchaSolution, EmailVerification, LoggedIn } from './CreateUser'
import { EmailVerificationStatus } from './EmailVerification'

export function AccountVerificationModal({
  enableCaptcha,
  onCaptchaSolved,
  emailVerification,
  onFailure,
  onSuccess,
}: {
  emailVerification: EmailVerification | undefined
  enableCaptcha: boolean
  onCaptchaSolved: (solution: CaptchaSolution) => void
  onSuccess: (loggedIn: LoggedIn) => void
  onFailure: () => void
}) {
  const [needSupport, setNeedSupport] = useState(false)
  return (
    <ModalDialog
      open={Boolean(emailVerification?.emailVerificationId) || enableCaptcha}
      onClose={onFailure}
    >
      <div className="flex flex-col items-center gap-8 p-4 pb-8">
        <PlainBrandIcon icon={SvgLogoMain} height={40} className="self-start" />

        <header className="label-lg pt-2">
          {enableCaptcha ? (
            <Trans>Are you a human?</Trans>
          ) : (
            <Trans>Waiting for email verification</Trans>
          )}
        </header>
        {enableCaptcha ? (
          <Captcha onCaptchaSolved={onCaptchaSolved} />
        ) : (
          emailVerification && (
            <EmailVerificationStatus
              emailVerification={emailVerification}
              onSuccess={onSuccess}
              onFailure={onFailure}
            />
          )
        )}
        {needSupport ? (
          <SupportChannels />
        ) : (
          <p>
            <Trans>
              Are you stuck? Please{' '}
              <button
                className="btn btn-link"
                onClick={() => setNeedSupport(true)}
              >
                contact support
              </button>
            </Trans>
          </p>
        )}
      </div>
    </ModalDialog>
  )
}
